import { NavLink } from "react-router-dom";
import Breadcumbs from "../../components/Breadcumbs";
import DataFetcherTemplate from "../../hooks/fetchTemplate";
import BannerGeneral from "../../components/BannerGeneral";
import BlockImageCabecera from "../../components/BlockImageCabecera";
import Accordion from "../../components/Accordion";
import BlockRightImage from "../../components/BlockRightImage";
import BlockLeftImage from "../../components/BlockLeftImage";
import Quote from "../../components/Quote";
import Block6Columns from "../../components/Block6Columns";
import calendario from "../../img/iconsoferta/calendario.png";
import modalidad from "../../img/iconsoferta/modalidad.png";
import titulo from "../../img/iconsoferta/titulo.png";
import sale from "../../img/iconsoferta/sale.png";
import campo from "../../img/iconsoferta/campo.png";
import inicio from "../../img/iconsoferta/inicio.png";
import Block3Columns from "../../components/Block3Columns";
import ConectUs from "../../components/ConectUs";
import {
  PosgradoPostulacion,
  NormativaPosgrados,
  PosgradoPostulacionFixed,
} from "../../components/Pasos";
import Modal from "../../components/Modal";

function DoctoradoQuimica() {

    function brochure(data) {
    if (data) {
      return (
        <>
          <a class="button" target="_blank" rel="noreferrer" href={data}>
            Brochure del programa 📕
          </a>
          <br></br>
        </>
      );
    }
  }

  const DataDisplay = ({ data }) => (


    <>
      <div>
        {data.map((item, index) => (
          <div>
            {" "}
            <BlockImageCabecera
              src={item.field_portada}
              title={
                <>
                  {" "}
                  <div
                    dangerouslySetInnerHTML={{
                      __html: item.field_texto_portada,
                    }}
                  />
                  {item.field_oferta_actual === "1" && (
                    <>
                      <a
                        className="button"
                        href={item.field_enlace_postulacion}
                      >
                        Postula ahora
                      </a>
                    </>
                  )}
                </>
              }
            ></BlockImageCabecera>
            <div className="graybg">
              <Breadcumbs
                content={
                  <>
                    <NavLink to="/posgrados">Posgrados</NavLink>
                    <span class="material-icons">chevron_right</span>
                    <NavLink to="/doctorado-quimica">
                      Doctorado en Química
                    </NavLink>
                  </>
                }
              ></Breadcumbs>
              <div className="padding oferta-icons">
                <Block6Columns
                  col1={
                    <>
                      <img src={titulo}></img>
                      <p>
                        <b>Título</b>
                      </p>
                      <p
                        dangerouslySetInnerHTML={{
                          __html: item.field_posgrado_titulo,
                        }}
                      />
                    </>
                  }
                  col2={
                    <>
                      <img src={modalidad}></img>
                      <p>
                        <b>Modalidad</b>
                      </p>
                      <p
                        dangerouslySetInnerHTML={{
                          __html: item.field_modalidad,
                        }}
                      />
                    </>
                  }
                  col3={
                    <>
                      <img src={calendario}></img>
                      <p>
                        <b>Duración</b>
                      </p>
                      <p
                        dangerouslySetInnerHTML={{
                          __html: item.field_posgrado_duracion,
                        }}
                      />
                    </>
                  }
                  col4={
                    <>
                      <img src={campo}></img>
                      <p>
                        <b>Campo amplio</b>
                      </p>
                      <p
                        dangerouslySetInnerHTML={{
                          __html: item.field_posgrado_campo,
                        }}
                      />
                    </>
                  }
                  col5={
                    <>
                      <img src={sale}></img>
                      <p>
                        <b>Precio</b>
                      </p>
                      <p
                        dangerouslySetInnerHTML={{
                          __html: item.field_precio,
                        }}
                      />
                    </>
                  }
                  col6={
                    <>
                      <img src={inicio}></img>
                      <p>
                        <b>Fecha de inicio</b>
                      </p>
                      <p
                        dangerouslySetInnerHTML={{
                          __html: item.field_inicio,
                        }}
                      />
                    </>
                  }
                ></Block6Columns>
              </div>
            </div>
            <div className="  graybg">
              <center>
                <p className="fontsize14">
                  🔈 Admisiones <b>abiertas</b>
                </p>
              </center>
              <div
                className="layout8"
                dangerouslySetInnerHTML={{
                  __html: item.field_bloque3,
                }}
              />
              <div className="layout6 margin"> 
              <div>
                <a
                  href="https://www.utpl.edu.ec/maestrias/sites/default/files/examen_oral_doctorado.pdf"
                  className="link-with-arrow"
                  target="_blank"
                >
                  {" "}
                  Conoce las rúbrica de evaluación del examen oral de admisión
                </a>
              </div>
              <div>
                <a
                  href="https://www.utpl.edu.ec/maestrias/sites/default/files/examen_escrito_doctorado.pdf"
                  className="link-with-arrow"
                  target="_blank"
                >
                  {" "}
                  Conoce las temáticas del examen escrito de admisión
                </a>
              </div></div>
              <br></br> <br></br>
            </div>
            <div className="layout8 margin">
               <div > {brochure(item.field_brochure)}</div>
              <div
                dangerouslySetInnerHTML={{
                  __html: item.field_pos_resolucion,
                }}
              />{" "}
              <div
                dangerouslySetInnerHTML={{
                  __html: item.field_posgrado_ingreso,
                }}
              />{" "}
            </div>
            <Quote
              content={
                <>
                  {" "}
                  <p
                    dangerouslySetInnerHTML={{
                      __html: item.field_posgrado_atributo,
                    }}
                  />
                </>
              }
            ></Quote>
            <BlockRightImage
              src={item.field_posgrado_imagenegreso}
              content={
                <>
                  {" "}
                  <div
                    dangerouslySetInnerHTML={{
                      __html: item.field_posgrado_egreso,
                    }}
                  />
                </>
              }
            ></BlockRightImage>{" "}
            <div className="layout6 padding2">
              {" "}
              <Accordion
                title="Malla curricular"
                content={
                  <>
                    {" "}
                    <div
                      dangerouslySetInnerHTML={{
                        __html: item.field_posgrado_malla,
                      }}
                    />{" "}
                  </>
                }
              ></Accordion>
              <Accordion
                title="Plan de trabajo anual"
                content={
                  <>
                    {" "}
                    <div
                      dangerouslySetInnerHTML={{
                        __html: item.field_bloque1,
                      }}
                    />{" "}
                  </>
                }
              ></Accordion>
            </div>
            <Quote
              content={
                <>
                  {" "}
                  <p
                    dangerouslySetInnerHTML={{
                      __html: item.field_posgrado_atributo2,
                    }}
                  />
                </>
              }
            ></Quote>{" "}
            <div className="graybg">
              <BlockLeftImage
                src={item.field_imagen_requisitos}
                content={
                  <>
                    {" "}
                    <div
                      dangerouslySetInnerHTML={{
                        __html: item.field_posgrado_requisitos,
                      }}
                    />{" "}
                    {item.field_oferta_actual === "1" && (
                      <div className="margin">
                        <a
                          className="button"
                          href={item.field_enlace_postulacion}
                        >
                          Postula ahora
                        </a>
                      </div>
                    )}
                  </>
                }
              ></BlockLeftImage>
              <BlockRightImage
                src={item.field_imagen2}
                content={
                  <>
                    {" "}
                    <div
                      dangerouslySetInnerHTML={{
                        __html: item.field_bloque2,
                      }}
                    />
                  </>
                }
              >
                {" "}
              </BlockRightImage>
            </div>
            <Quote
              content={
                <>
                  {" "}
                  <p
                    dangerouslySetInnerHTML={{
                      __html: item.field_posgrado_atributo3,
                    }}
                  />
                </>
              }
            ></Quote>{" "}
            <div className="bluebg padding">
              <div className="layout8">
                <center>
                  {" "}
                  <h2>
                    ¿Qué <b>nos diferencia?</b>
                  </h2>
                </center>
              </div>

              <Block3Columns
                col1={
                  <div
                    dangerouslySetInnerHTML={{
                      __html: item.field_posgrado_diferencia,
                    }}
                  />
                }
                col2={
                  <div
                    dangerouslySetInnerHTML={{
                      __html: item.field_posgrado_diferencia2,
                    }}
                  />
                }
                col3={
                  <div
                    dangerouslySetInnerHTML={{
                      __html: item.field_posgrado_diferencia3,
                    }}
                  />
                }
              ></Block3Columns>
              <br></br>
            </div>
            <div className="wrapper-docente  ">
              <div
                className="layout6 padding2"
                dangerouslySetInnerHTML={{
                  __html: item.field_texto_docente,
                }}
              />

              <div
                className="flex-center"
                dangerouslySetInnerHTML={{
                  __html: item.field_docente,
                }}
              />
            </div>
          </div>
        ))}

        <div>
          <Quote
            content={
              <p>
                Implementamos adaptaciones curriculares no significativas, como
                ajustes en tiempos de entrega y recursos, con el fin de
                garantizar el cumplimiento de los objetivos de aprendizaje.
                Estas adaptaciones pueden aplicarse tanto a estudiantes con
                discapacidad como a aquellos que no presentan dicha condición.
              </p>
            }
          ></Quote>
        </div>
      </div>
    </>
  );

  return (
    <>
      <DataFetcherTemplate url="https://www.utpl.edu.ec/maestrias/services/doctorado-quimica.json">
        {(data) => <DataDisplay data={data} />}
      </DataFetcherTemplate>
      <div className="margin  ">
        {" "}
        <div className="layout6">
          <center>
            <h2 className="width500">
              {" "}
              <b>¿Interesado </b>en nuestro programa?
            </h2>

            <p>
              {" "}
              📩 Escríbenos a <b> doctoradoquimica@utpl.edu.ec</b> o
            </p>

            <p>
              ☎️ llámanos al <b>(07) 370 1444, ext. 3414</b> para más
              información ✨{" "}
            </p>
          </center>
        </div>
      </div>
      <ConectUs
        lema="Descubre contenido exclusivo, mantente al tanto de las últimas novedades y únete a nuestra comunidad de estudiantes de posgrado."
        instagram="https://www.instagram.com/utplposgrados/"
        facebook="https://www.facebook.com/utplposgrados"
      ></ConectUs>
      <BannerGeneral></BannerGeneral>
    </>
  );
}

export default DoctoradoQuimica;
